import { useConsentedFeatureFlagVariantKey } from '@restworld/utils-common';

// The ONLY file that imports this flag name — do not read REFERRAL_UX_FLAG elsewhere.
export const REFERRAL_UX_FLAG = 'referral-ux-variant';

export type ReferralVariant = 'page' | 'modal';

// 'control' → old page flow (production baseline).
// 'modal'   → new invite modal.
// undefined / anything else → fall back to 'page' (control = current production when flag is unresolved).
const flagToVariant = (v: unknown): ReferralVariant => (v === 'modal' ? 'modal' : 'page');

// Consent-gated: users without Measurement consent stay on 'page' (control) and
// are never exposed to the experiment (see useConsentedFeatureFlagVariantKey).
export const useReferralVariant = (): ReferralVariant => {
  const flag = useConsentedFeatureFlagVariantKey(REFERRAL_UX_FLAG);
  return flagToVariant(flag);
};
